const ThDayHdg = ({ d }) => {
  return (
    <th
      className="center"
      style={{ width: "11.11111111%", fontSize: "0.9rem" }}
    >
      {d}
    </th>
  );
};

export default ThDayHdg;
